// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";


// Initialise our components on jQuery.ready…
// jQuery(function ($) {
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();
// });

jQuery(function ($) {


    jQuery('#offCanvas').offcanvas({
        modifiers: 'right, overlay', // default options
        triggerButton: '#triggerButton', // btn to open offcanvas
        closeButtonClass: "js-offcanvas-close",
      });
    
      // Properly update the ARIA states on focus (keyboard) and mouse over events
      $('[role="menubar"]').on('focus.aria  mouseenter.aria', '[aria-haspopup="true"]', function (ev) {
        $(ev.currentTarget).attr('aria-expanded', true);
      });
    
      // Properly update the ARIA states on blur (keyboard) and mouse out events
      $('[role="menubar"]').on('blur.aria  mouseleave.aria', '[aria-haspopup="true"]', function (ev) {
        $(ev.currentTarget).attr('aria-expanded', false);
      });
    


  var $fp_slider = jQuery('.image-slider');
  $fp_slider.slick({
    dots: false,
    arrows: true,
    prevArrow: $('.image-slider-slider-arrow--left'),
    nextArrow: $('.image-slider-slider-arrow--right'),
  });

  var $p_slider = jQuery('.js-partner-slider');
  $p_slider.slick({
    slidesToShow: 4,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: $('.js-partner-slider-slider-arrow--left'),
    nextArrow: $('.js-partner-slider-slider-arrow--right'),
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
    ]
  });

  

    
});